import React, {useEffect, useState} from 'react'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core'
import axios from 'axios' // import axios here

am4core.useTheme(am4themes_animated)

interface FundingByCategory {
  category: string
  total_funding: number
}

const FundingByCategory: React.FC = () => {
  const [data, setData] = useState<FundingByCategory[]>([])
  const [pieChart, setPieChart] = useState<am4charts.PieChart | null>(null)
  const [barChart, setBarChart] = useState<am4charts.XYChart | null>(null)

  useEffect(() => {
    fetchData()
    return () => {
      pieChart?.dispose()
      barChart?.dispose()
    }
  }, [])

  const fetchData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/funding-by-category`)
      const result: FundingByCategory[] = response.data
      const filteredData = result.filter(
        (item) => item.category.trim() !== '' && item.total_funding !== null
      )
      setData(filteredData)
      createPieChart(filteredData)
      createBarChart(filteredData)
    } catch (error) {
      console.error('Error fetching data: ', error)
    }
  }

  const createPieChart = (chartData: FundingByCategory[]) => {
    const newChart = am4core.create('piechartdiv', am4charts.PieChart)
    newChart.data = chartData

    const series = newChart.series.push(new am4charts.PieSeries())
    series.dataFields.value = 'total_funding'
    series.dataFields.category = 'category'
    series.labels.template.disabled = true

    newChart.legend = new am4charts.Legend()
    newChart.legend.position = 'right'

    setPieChart(newChart)
  }

  const createBarChart = (chartData: FundingByCategory[]) => {
    const newChart = am4core.create('barchartdiv', am4charts.XYChart)
    newChart.data = chartData

    const categoryAxis = newChart.xAxes.push(new am4charts.CategoryAxis())
    categoryAxis.dataFields.category = 'category'

    const valueAxis = newChart.yAxes.push(new am4charts.ValueAxis())

    const series = newChart.series.push(new am4charts.ColumnSeries())
    series.dataFields.valueY = 'total_funding'
    series.dataFields.categoryX = 'category'

    setBarChart(newChart)
  }

  // const formatCurrency = (value: number | null) => {
  //   if (value === null) {
  //     return ''
  //   }
  //   return '$' + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
  // }

  const formatCurrency = (value: number | string | null) => {
    if (value === null) {
      return ''
    }
    const numValue = typeof value === 'string' ? parseFloat(value) : value
    return '$' + numValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
  }

  return (
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
      <Typography variant='h4' style={{marginBottom: '40px'}}>
        IIJA Funding by Category
      </Typography>
      <TableContainer component={Paper} style={{maxWidth: '50%', marginBottom: '20px'}}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant='h6'>Category</Typography>
              </TableCell>
              <TableCell align='right'>
                <Typography variant='h6'>Total Funding</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item) => (
              <TableRow key={item.category}>
                <TableCell component='th' scope='row'>
                  <Typography variant='body1'>{item.category}</Typography>
                </TableCell>
                <TableCell align='right'>
                  <Typography variant='body1'>{formatCurrency(item.total_funding)}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div id='piechartdiv' style={{width: '50%', height: '400px'}}></div>
    </div>
  )
}

export default FundingByCategory
